import * as NetworkStapler from "network-stapler";
import { config } from "aaa";
import { auth } from "models/Auth";
import * as queryString from "querystring";
const urljoin = require("url-join");

class APIClient {

    private apiClient: NetworkStapler.APIClient;

    constructor(baseUrl: string) {
        this.apiClient = new NetworkStapler.APIClient({
            baseUrl: baseUrl,
            injectHeaders: (target => {

                let addContentType = true;
                if (target.headers) {
                    addContentType = target.headers["Content-Type"] ? false : true;
                }
                return {
                    ...target.headers,
                    // "Authorization": `Bearer ${auth.token!.accessToken}`,
                    "Content-Type": addContentType ? "application/json" : target.headers!["Content-Type"]
                };
            }),
            throwOnErrorStatusCodes: true
        });
    }

    injectAuthorization(target: any, authorized: boolean) {
        if (authorized && auth.token) {
            target.headers = {
                ...target.headers,
                "Authorization": `Bearer ${auth.token!.accessToken}`,
            };
        }
    }

    request(target: NetworkStapler.IAPITarget, authorized = false): Promise<Response> {
        this.injectAuthorization(target, authorized);
        return this.apiClient.request(target).catch(this.checkStatusCodeError);
    }

    requestJSON(target: NetworkStapler.IAPITarget, authorized = false): Promise<object> {
        this.injectAuthorization(target, authorized);
        return this.apiClient.requestJSON(target).catch(this.checkStatusCodeError);
    }

    requestType<T>(target: NetworkStapler.ITypedAPITarget<T>, authorized = false): Promise<T> {
        this.injectAuthorization(target, authorized);
        return this.apiClient.requestType(target).catch(this.checkStatusCodeError);
    }

    checkStatusCodeError(error: any): any {
        if (error instanceof NetworkStapler.APIClientStatusCodeError) {
            if (error.statusCode && error.statusCode === 401) {
                // unauthorize user on 401
                auth.token = undefined;
                throw error;
            }
        }
        throw error;
    }

    uploadFormData(target: NetworkStapler.IAPITarget, authorized = false): Promise<Response> {
        this.injectAuthorization(target, authorized);

        let headers = target.headers;
        if (!headers) {
            headers = {};
        }

        // FormData with fetch must not have Content-Type set. This gets set automatically by
        // fetch()
        delete headers["Content-Type"];

        const query = queryString.stringify(target.queryParameters);
        let requestUrl = urljoin(this.apiClient.options.baseUrl, target.url);
        if (query) {
            requestUrl = urljoin(requestUrl, "?" + query);
        }

        const options = {
            method: target.method || "GET",
            body: target.body,
            headers: headers as any
        };

        return fetch(requestUrl, options)
            .then((response: any) => {
                if (this.apiClient.options.throwOnErrorStatusCodes) {
                    if (response.status >= 200 && response.status < 400) {
                        return response.json();
                    }
                    throw new NetworkStapler.APIClientStatusCodeError(response, response.status);
                } else {
                    return response;
                }
            });
    }
}

// console.log("### Creating APIClient", config.API_BASE_URL);
export const apiClient = new APIClient(config.API_BASE_URL);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/network/apiClient.ts